import { Outlet } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import { Toaster as Sonner } from "./components/ui/sonner";
import { TooltipProvider } from "./components/ui/tooltip";

/** Layout wrapper for property portal routes (providers + outlet). */
export function PropertyPortalProviders() {
  return (
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <Outlet />
    </TooltipProvider>
  );
}

/** Standalone entry (`propertyPortal/main.tsx`) expects a default export. */
export default PropertyPortalProviders;
